import { AbstractFacade, plainToInstanceWithLVS } from '@goparrot/common';
import deepmerge from 'deepmerge';
import { stringify } from 'qs';
import { ImportValidationResponseDto } from '../dto';
import { UserImportExposeGroup } from '../interface';
export class UserImportFacade extends AbstractFacade {
    constructor(config = {}, interceptors) {
        super(deepmerge({
            axiosConfig: {
                baseURL: process.env.GOPARROT_PLATFORM_SERVICE_CUSTOMER,
            },
        }, config), interceptors);
    }
    async upload(merchantId, formData, params = {
        type: 'toast',
    }) {
        return plainToInstanceWithLVS(ImportValidationResponseDto, (await this.client.post(`api/v2/merchants/${merchantId}/imports`, formData, {
            headers: this.getFormDataHeaders(formData),
            params,
            paramsSerializer: stringify,
        })).data, {
            groups: [UserImportExposeGroup.READ],
        });
    }
    async errors(merchantId, importId) {
        return (await this.client.get(`/api/v2/merchants/${merchantId}/imports/${importId}`)).data;
    }
}
//# sourceMappingURL=user-import.facade.js.map